export { default as Colors } from './colors';



// WEBPACK FOOTER //
// ./src/variables/index.js